import { useRef, useEffect, useState } from "react";
import { fetchOurTeamData } from "../../services/api";

const Base_URL = process.env.REACT_APP_Base_URL;

const getImageUrl = (img, fallbackImg = null) => {
  if (Array.isArray(img)) img = img[0];
  if (Array.isArray(fallbackImg)) fallbackImg = fallbackImg[0];
  const extractUrl = (image) => {
    if (!image) return null;
    return (
      image.url ||
      null
    );
  };
  const url = extractUrl(img) || extractUrl(fallbackImg);
  return url ? `${Base_URL}${url}` : "/fallback.jpg";
};

export default function OurTeamHome({ lang = "en" }) {
  const [teamData, setTeamData] = useState(null);
  const [enTeamData, setEnTeamData] = useState(null);
  const [loading, setLoading] = useState(true);
  const containerRefs = useRef([]);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1024);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setLoading(true);
    setTeamData(null);

    const loadData = async () => {
      try {
        // Always fetch English as fallback
        const enRes = await fetchOurTeamData("en");
        const enItem = Array.isArray(enRes) ? enRes[0] : enRes;
        setEnTeamData(enItem || null);

        if (lang !== "en") {
          const localRes = await fetchOurTeamData(lang);
          const localItem = Array.isArray(localRes) ? localRes[0] : localRes;

          // Check if local data is valid and not empty
          const hasLocalData =
            localItem &&
            typeof localItem === "object" &&
            Object.keys(localItem).length > 0;

          if (hasLocalData) {
            // Merge — use local text, fall back to English images
            const merged = {
              ...enItem,
              ...localItem,
              Our_Team: (localItem.Our_Team || enItem?.Our_Team || []).map(
                (item, index) => {
                  const enMember = enItem?.Our_Team?.[index] || {};
                  return {
                    ...enMember,
                    ...item,
                    // Always use English images if local missing
                    team_image: item.team_image || enMember.team_image,
                    mobile_image: item.mobile_image || enMember.mobile_image,
                  };
                }
              ),
            };
            setTeamData(merged);
          } else {
            // No local data — use English
            setTeamData(enItem);
          }
        } else {
          setTeamData(enItem);
        }
      } catch (err) {
        console.error("Error loading team:", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [lang]);

  if (loading) return <p className="p-6">Loading...</p>;
  if (!teamData) return null;

  return (
    <div className="padding-x-40 padding-y-80 our-team-home">
      <div className="section-name-wrapper">
        <div className="section-name-dot"></div>
        <h6 className="section-name">{teamData?.Section_Name}</h6>
      </div>

      <h3 className="size-h3 col-xl-9 pt-2.5 text-dark-blue-color" style={{ marginBottom: "30px" }}>
        {teamData?.Section_Heading}
      </h3>

     

      <div className="custom-lg-flex flex flex-wrap justify-between items-start mt-160">
        {teamData?.Our_Team?.map((item, index) => {
          const enItem = enTeamData?.Our_Team?.[index] || {};

          return (
            <div
              key={item.id}
              className="w-[48%] md:w-[31.5%] 3xl:w-[15%] flex flex-wrap items-end justify-center md:pb-5 pb-10"
              ref={(el) => (containerRefs.current[index] = el)}
            >
              <div className="w-full">
                <img
                  className="hidden md:block"
                  src={getImageUrl(item.team_image, enItem?.team_image)}
                  alt={item.team_member_name}
                  style={{ width: "100%", height: "auto", borderRadius: "10px" }}
                  onError={(e) => {
                    const fallback = getImageUrl(enItem?.team_image);
                    if (e.target.src !== fallback) e.target.src = fallback;
                    else e.target.src = "/fallback.jpg";
                  }}
                />
                <img
                  className="md:hidden"
                  src={getImageUrl(item.mobile_image, enItem?.mobile_image)}
                  alt={item.team_member_name}
                  style={{ width: "100%", height: "auto", borderRadius: "10px" }}
                  onError={(e) => {
                    const fallback = getImageUrl(enItem?.mobile_image);
                    if (e.target.src !== fallback) e.target.src = fallback;
                    else e.target.src = "/fallback.jpg";
                  }}
                />
                <h5 className="size-h5 pt-5" style={{ color: "rgba(25,175,225,1)", marginBottom: "0" }}>
                  {item.team_member_name}
                </h5>
                <p className="font-medium text-dark-blue-color pt-1 pb-2.5">
                  {item.team_member_designation}
                </p>
              </div>
            </div>
            
          );
        })}
      </div>
       <a className="text-link mt-4 block" style={{display:'block'}} href={teamData?.Our_Team_Redirection_Url || "#"}>
        {teamData?.Our_Team_Redirection_Text || ""}
      </a>
    </div>
  );
}